// extracted by mini-css-extract-plugin
export default {"account-button":"buttons_account-button__hmf-k","account-button-header":"buttons_account-button-header__Ds2uw"};